import React from 'react';
import {Card, CardContent, CardHeader} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import DoneIcon from '@material-ui/icons/Done';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import {useTranslation} from "react-i18next";

function AdminPermissionInfo(props: any) {

    const {t} = useTranslation();
    const {onClose} = props;

    const handleClose = () => {
        onClose(false);
    };

    function createData(type: any, full_admin: any, partial_admin: any) {
        return {type, full_admin, partial_admin};
    }

    const rows = [
               createData(t('Admin.Type.Permissions.ManageSubscriptions'), <DoneIcon/>, <DoneIcon/>),
               createData(t('Admin.Type.Permissions.ManageProvidersGuestsAndProGuestsGroups'), <DoneIcon/>, <DoneIcon/>),
               createData(t('Admin.Type.Permissions.ManageMachines'), <DoneIcon/>, <DoneIcon/>),
               createData(t('Admin.Type.Permissions.DelegateAdminRightsToOtherUsers'), <DoneIcon/>, <DoneIcon/>),
               createData(t('Admin.Type.Permissions.DeleteAccount'), <DoneIcon/>, ''),
               createData(t('Admin.Type.Permissions.TransferAccountOwnership'), <DoneIcon/>, ''),
    ];

    return (
               <Card>
                        <CardHeader title={t('Admin.Type.Title')} action={
                               <IconButton onClick={handleClose}>
                                        <CloseIcon style={{color: "white"}}/>
                </IconButton>
            }>
            </CardHeader>
                        <CardContent>
                                <TableContainer>
                                        <Table size="small" aria-label="a dense table">
                                                <TableHead>
                                                        <TableRow>
                                                                <TableCell/>
                                                                <TableCell align="center">{t('Admin.Type.536870911')}</TableCell>
                                                                <TableCell align="center">{t('Admin.Type.2147483647')}</TableCell>
                            </TableRow>
                        </TableHead>
                                                <TableBody>
                            {rows.map(row => (
                                                               <TableRow key={row.type}>
                                                                        <TableCell component="th" scope="row">
                                        {row.type}
                                    </TableCell>
                                                                        <TableCell align="center">{row.partial_admin}</TableCell>
                                                                        <TableCell align="center">{row.full_admin}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}

export default AdminPermissionInfo;
